import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { Library, LayoutDashboard, Building2, Hammer, Wrench, Sparkles, Scale, Zap, ClipboardList } from 'lucide-react';
import EnquiryTracker from './crm/EnquiryTracker';
import EnquiryDetail from './crm/EnquiryDetail';
import SiteVisitReport from './crm/SiteVisitReport';
import PotentialVendors from './crm/PotentialVendors';
import RateLibrary from './estimation/RateLibrary';
import EstimationDashboard from './estimation/EstimationDashboard';
import CostMaster from './estimation/CostMaster';
import AutoRateAnalysis from './estimation/AutoRateAnalysis';
import PEBTonnageCalc from './estimation/PEBTonnageCalc';
import TonnageCalcAI from './estimation/TonnageCalcAI';

// Tendering_30Sep2026: the Tender Register tab is retired — the Enquiry
// Tracker (CRM) is the only tender record. This tab bar now mirrors the
// sidebar's "Tendering" group exactly, and Enquiry Tracker / Potential
// Vendors render INSIDE this same tab layout (sticky tab bar, right tab
// highlighted) instead of navigating out to a separate CRM page.
const TABS = [
  { to: '/app/estimation/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/app/estimation/enquiries', label: 'Enquiry Tracker', icon: ClipboardList },
  { to: '/app/estimation/potential-vendors', label: 'Potential Vendors', icon: Hammer },
  { to: '/app/estimation/rate-library', label: 'Rate Library', icon: Library },
  { to: '/app/estimation/auto-analysis', label: 'Auto Rate · AI', icon: Sparkles },
  { to: '/app/estimation/peb-tonnage', label: 'PEB Tonnage', icon: Scale },
  { to: '/app/estimation/tonnage-ai', label: 'Tonnage · AI', icon: Zap },
  { to: '/app/estimation/master/materials', label: 'Materials', icon: Building2 },
  { to: '/app/estimation/master/labour', label: 'Labour', icon: Hammer },
  { to: '/app/estimation/master/equipment', label: 'Equipment', icon: Wrench },
];

export default function Estimation() {
  return (
    <div className="space-y-5" data-testid="estimation-page">
      <div className="border-b border-slate-200 bg-white">
        <nav className="flex gap-1 overflow-x-auto px-2">
          {TABS.map(t => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`estimation-tab-${t.to.replace(/\//g, '-').replace(/^-/, '')}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  isActive
                    ? 'text-[#3b4872] border-[#3b4872]'
                    : 'text-slate-600 border-transparent hover:text-[#0F172A] hover:bg-slate-50'
                }`
              }
            >
              <t.icon size={14} />
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<EstimationDashboard />} />
        <Route path="enquiries" element={<EnquiryTracker />} />
        <Route path="enquiries/new" element={<EnquiryDetail />} />
        <Route path="enquiries/:id" element={<EnquiryDetail />} />
        <Route path="enquiries/:id/svr" element={<SiteVisitReport />} />
        <Route path="potential-vendors" element={<PotentialVendors />} />
        {/* Tendering_30Sep2026: Tender Register retired — send old links to the Enquiry Tracker */}
        <Route path="tenders" element={<Navigate to="/app/estimation/enquiries" replace />} />
        <Route path="tenders/:tenderId" element={<Navigate to="/app/estimation/enquiries" replace />} />
        <Route path="rate-library" element={<RateLibrary />} />
        <Route path="auto-analysis" element={<AutoRateAnalysis />} />
        <Route path="peb-tonnage" element={<div className="p-6 md:p-8"><PEBTonnageCalc /></div>} />
        <Route path="tonnage-ai" element={<TonnageCalcAI />} />
        <Route path="master/:kind" element={<CostMaster />} />
      </Routes>
    </div>
  );
}
